// The calendar older versions of Emrouz made on the phone and filled with the
// user's own occasions. Emrouz no longer writes it, and it was left on the
// phone as the user's own. The reader still leaves it out of everything it
// reads, and settings leaves it out of the list of calendars: an occasion of
// ours read back out of it would be the same day twice.

export const OCCASION_CALENDAR = 'مناسبت‌های امروز'

export const MIRROR_CALENDARS = [OCCASION_CALENDAR]
